// extracted by mini-css-extract-plugin
export default {"CommonButton":"CommonButton_CommonButton__HkeWb"};